module.exports = __webpack_public_path__ + "static/img/Crane_Logo_blue.56e81513.png";